import { BasePage as CngBasePage } from 'cng-web-lib'
import React from 'react'
import MasterUpload from './MasterUpload.js'
import useBreadcrumbNameMap from 'src/navigations/breadcrumbs/Breadcrumb_TmpADMIN'
import TranslationText from './TranslationText'

//* Module Title ---------------------------------------------------------------
function ModuleTitle() {
  const translatedTextsObject = TranslationText();
  const moduleTitle = translatedTextsObject.moduleTitle;
  return moduleTitle;
}

function WrappedUploadPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      moduleTitle={ModuleTitle()}
      renderPage={(showSnackbar) => (
        <MasterUpload showNotification={showSnackbar} {...props} />
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}


export {
  WrappedUploadPage as UploadPage,
}
